import LeadAdd from "./leadAdd"

export default LeadAdd
